import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd"; // If you're using @hello-pangea/dnd, ensure consistency!
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import styles from "../../styles/Building MGMT/ImageUploader.module.css";

const API_BASE_URL = import.meta.env.VITE_API_URL;

const ImageUploader = ({ images, onUploadSuccess, unitId }) => {
  // Maintain our internal state for uploaded images (default to empty array if not provided)
  const [uploadedImages, setUploadedImages] = useState(images || []);
  const [coverImage, setCoverImage] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(-1);

  // Remove any useEffect from within drag handlers – we only need this at the top level if desired.
  // (For this example, ordering is controlled by the parent via ImageStack.)

  const handleDragEnd = ({ source, destination }) => {
    if (!destination) return;
    const list = Array.from(uploadedImages);
    const [moved] = list.splice(source.index, 1);
    list.splice(destination.index, 0, moved);
    setUploadedImages(list);
  };

  const handleFilesAdded = async (e) => {
    const filesArray = Array.from(e.target.files);
    const formData = new FormData();
    filesArray.forEach((file) => formData.append("images", file));

    try {
      const uploadRes = await fetch(`${API_BASE_URL}/upload/${unitId}`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });
      if (!uploadRes.ok) throw new Error("Image upload failed.");
      const { uploadedImages: newImages } = await uploadRes.json();
      // Format new images as { id, src }
      const formatted = newImages.map((img) => ({
        id: img.ImageID,
        src: img.ImageURL,
      }));
      setUploadedImages((prev) => [...prev, ...formatted]);
      onUploadSuccess(formatted);
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  const openLightbox = (index) => {
    setLightboxIndex(index);
  };

  // Compose final images: if a cover image is set, place it first.
  const allImages = coverImage ? [coverImage, ...uploadedImages] : uploadedImages;

  return (
    <div className={styles.uploader}>

      <label className={styles.uploadButton}>
        📁 Add Images
        <input type="file" multiple hidden onChange={handleFilesAdded} />
      </label>

      <Lightbox
        open={lightboxIndex >= 0}
        index={lightboxIndex}
        close={() => setLightboxIndex(-1)}
        slides={allImages.map((img) => ({ src: img.src }))}
      />
    </div>
  );
};

export default ImageUploader;
